import styled from 'styled-components';

export const ThankYouWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
      border-radius: 1rem;
      box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
      background-color: ${props.theme.colors.white.base};
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l18};
  `
);
